import { SMOOTH_RATE } from "./endpoints"
import { fetcher } from "./utils"

export type SmoothingRate = {
    vat: number;
    test_id: number;
    inbar12: number;
    wasserman9: number;
}

export const getSmoothingRate = async (testId: string): Promise<SmoothingRate> => {
    const data = await fetcher(SMOOTH_RATE, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            test_id: testId,
        }
    });

    return data;
}

export const updateSmoothingRate = async ({ testId, vat, inbar12, wasserman9 }: {
    testId?: string;
    vat?: number;
    inbar12?: number; 
    wasserman9?: number;
}): Promise<SmoothingRate | null> => {
    if (!testId) return null;
    
    const data = await fetcher(SMOOTH_RATE, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            test_id: testId
        },
        body: JSON.stringify({
            vat,
            inbar12,
            wasserman9,
        })
    });

    return data;
}